import { render, staticRenderFns } from "./AboDBParameters.vue?vue&type=template&id=b5f9ff26&scoped=true"
import script from "./AboDBParameters.vue?vue&type=script&lang=js"
export * from "./AboDBParameters.vue?vue&type=script&lang=js"
import style0 from "./AboDBParameters.vue?vue&type=style&index=0&id=b5f9ff26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f9ff26",
  null
  
)

export default component.exports